import { useState } from "react";

export default function useModal(initialValue = false) : Array<any> {

    const [isOpenModal, setIsOpenModal] = useState(initialValue);

    function openModal() : void {
        setIsOpenModal(true);
    }

    function closeModal() : void {
        setIsOpenModal(false);
    }

    return [isOpenModal, openModal, closeModal];
}